/* eslint-disable @typescript-eslint/no-explicit-any */
import { safeJsonParse } from "@/zapi-frontend/utils/safeJsonParse";
import { MAX_DIFF_AGE } from "@/zapi-frontend/shared/const/consts";

function fixEditorState(editorState: any): any {
  if (!editorState) return null;
  if (!editorState.timestamp)
    return {
      htmlContent: editorState.htmlContent,
      timestamp: new Date().toISOString()
    };
  else if (editorState.timestamp && new Date(editorState.timestamp).getTime() < Date.now() - MAX_DIFF_AGE) return null;
  else return editorState;
}

// transformation for diff storage:
// 1. If the diff is older than 3 days, it is removed.
// 2. In the previous version timestamps were missing, so we add them in case they are missing.
export function transformDiffStorage(value: string | null): string | null {
  if (!value) return null;
  try {
    const v = safeJsonParse(value, {});
    const editorStates = v?.state?.editorStates;
    if (!editorStates) return null;

    const cleanedEditorStates = Object.fromEntries(
      Object.entries(editorStates).map(([key, value]) => [key, fixEditorState(value)])
    );

    const final = JSON.stringify({
      ...v,
      state: {
        ...v.state,
        editorStates: cleanedEditorStates
      }
    });

    return final;
  } catch (error) {
    console.error("Error transforming diff storage:", error);
    return value;
  }
}
